// extracted by css-extract-rspack-plugin
export default {"panel":"SelectOverlay-module__panel___TXQmP"};